import { FileRepresenting } from './asset';
import { PaginatedLoaderResponse, paginatedLoaderResponseFrom } from './data';
import { api, writeDB } from './store';

/* INTERFACES */
interface NewsBase {
  id: string;
  title?: string | null;
  titleEn?: string | null;
  titleDe?: string | null;
  textEn?: string | null;
  textDe?: string | null;
  url?: string | null;
  inverse?: boolean | null;
  asset?: File | null;
  order?: number;
  createdAt: Date | null;
  category?: string | null;
  shopId?: string;

  image?: FileRepresenting | null;
}

export interface News extends NewsBase {
  meta?: Record<string, JSONValue>;
}

export interface NewsEdit extends NewsBase {
  meta?: string;
}

/* NEWS READ */
export async function getNews({
  term,
  shopId,
  page,
  perPage,
}: {
  term?: string;
  shopId?: string;
  page?: number;
  perPage?: number;
}): Promise<PaginatedLoaderResponse> {
  const response = await api.indexNews({
    page: (page || 0) + 1,
    perPage,
    term,
    shopId,
  });
  writeDB.table('news').upsert(response.data);
  return paginatedLoaderResponseFrom(response);
}

/* NEWS UPDATE */
export async function editNews(newsId: string, model: Partial<News>): Promise<void> {
  const response = await api.updateNews({
    newsId,
    ...model,
  });
  writeDB.table('news').upsert(response.data);
}

/* NEWS DELETE */
export async function deleteNews(newsId: string): Promise<void> {
  await api.destroyNews({ newsId });
  writeDB.table('news').delete(newsId);
}
